import { Link } from "react-router-dom";
import { FiChevronRight, FiX } from "react-icons/fi";
import styles from "./BannerManager.module.scss";

const BANNER_TYPES = ["info", "warning", "danger"];


const pickTopMessage = (messages = []) =>
  messages
    .filter(Boolean)
    .reduce(
      (top, message) =>
        !top || Number(message.priority || 0) > Number(top.priority || 0)
          ? message
          : top,
      null,
    );


const BannerManager = ({ messages, onDismiss }) => {
  const message = pickTopMessage(messages);
  if (!message) return null;

  const type = BANNER_TYPES.includes(message.type) ? message.type : "info";
  const { cta } = message;
  const ctaContent = (
    <>
      {cta?.label}
      <FiChevronRight className={styles.ctaArrow} aria-hidden="true" />
    </>
  );

  return (
    <>
      <div
        className={`${styles.banner} ${styles[type]}`}
        role={type === "danger" ? "alert" : "status"}
        data-banner-id={message.id}
      >
        <span className={styles.text}>{message.text}</span>
        {cta?.label &&
          (cta.href && !cta.onClick ? (
            <Link to={cta.href} className={styles.cta}>
              {ctaContent}
            </Link>
          ) : (
            <button type="button" className={styles.cta} onClick={cta.onClick}>
              {ctaContent}
            </button>
          ))}
        {message.dismissible && (
          <button
            type="button"
            className={styles.dismiss}
            aria-label="Dismiss announcement"
            onClick={() => onDismiss?.(message)}
          >
            <FiX aria-hidden="true" />
          </button>
        )}
      </div>
      <div className={styles.spacer} aria-hidden="true" />
    </>
  );
};

export default BannerManager;
